export enum MdaDialogStep {
  Sign = 'Sign',
  Decline = 'Decline',
}
